import React from 'react';
import toast from 'react-hot-toast';
import Modal from '../Modal';
import { parseARGB } from '../../hooks';

const ColorSelectModal = ({
  open,
  onClose,
  availableColors,
  selectedColor,
  setSelectedColor,
  onSave,
  isSaving
}) => {
  if (!open) return null;

  return (
    <Modal onClose={onClose} hideOverlay>
      <div className="w-[350px]">
        <h3 className="text-lg font-semibold mb-4">Select Track Color</h3>

        {/* Preset Colors */}
        <div className="mb-6">
          <div className="flex justify-between gap-3 flex-wrap">
            {availableColors.map((color, index) => (
              <button
                key={index}
                onClick={() => setSelectedColor(color)}
                className={`w-10 h-10 rounded-full border-2 transition-all cursor-pointer ${
                  selectedColor === color
                    ? 'border-blue-500 scale-110 ring-2 ring-blue-200'
                    : 'border-gray-200 hover:scale-105'
                }`}
                style={{
                  backgroundColor: parseARGB(color).color,
                  opacity: parseARGB(color).opacity
                }}
                title={color}
              />
            ))}
          </div>
        </div>

        {/* Selected Preview */}
        <div className="mb-4 p-3 bg-gray-50 rounded-lg flex justify-between items-center">
          <span className="text-sm font-medium text-gray-700">Selected:</span>
          <div className="flex items-center gap-2">
            <div
              className="w-6 h-6 rounded-full border"
              style={{
                backgroundColor: parseARGB(selectedColor).color,
                opacity: parseARGB(selectedColor).opacity
              }}
            />
            <span className="text-sm font-mono">{selectedColor}</span>
          </div>
        </div>

        {/* Actions */}
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 cursor-pointer"
          >
            Cancel
          </button>

          <button
            onClick={onSave}
            disabled={isSaving || !selectedColor}
            className="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 cursor-pointer"
          >
            {isSaving ? 'Saving...' : 'Save Color'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ColorSelectModal;

